export default "__VITE_ASSET__BP2yGoip__"